import AxiosInitializer from 'api/Utility/AxiosInitializer'
import getToken from 'lib/authentication/GetToken'
import apiWrapper from 'api/Utility/ApiWrapper'
import { handleStatus500 } from 'api/Utility/HandleStatus500'

const axiosRequest = (extraParams: any = {}) => {
  const params = {
    token: getToken(),
    paramsSerializerConfig: true,
    ...extraParams,
  }

  return AxiosInitializer({
    ...params,
  })
}

const stakeHolderEndPoint = {
  fetchSignInActivity: (params = {}) => {
    return axiosRequest().get(`reporting/shared_dashboard_link`, {
      params,
    })
  },
  fetchFilterParams: (params = {}) => {
    return axiosRequest().get(
      `/reporting/stakeholder_dashboards/fetch_filter_params`,
      {
        params,
      },
    )
  },
}

const stakeHolderDetailsAPI = {
  fetchFilterParams: (params = {}) =>
    apiWrapper({
      endPoint: stakeHolderEndPoint.fetchFilterParams,
      params,
      errorFailureAction: handleStatus500,
    }),
  fetchSignInActivity: (params = {}) =>
    apiWrapper({
      endPoint: stakeHolderEndPoint.fetchSignInActivity,
      params,
      errorFailureAction: handleStatus500,
    }),
}

export default stakeHolderDetailsAPI
